import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Building2, ChevronDown, Check, Search } from 'lucide-react';
import { useOrg } from '../contexts/OrgContext';

export default function OrgSwitcher() {
  const { orgs, active, refresh, switchTo } = useOrg();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!open) return;
    const onDown = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onDown);
    return () => document.removeEventListener('mousedown', onDown);
  }, [open]);

  const toggle = () => {
    setOpen((wasOpen) => {
      if (!wasOpen) refresh();
      return !wasOpen;
    });
  };

  const pick = (org) => {
    switchTo(org);
    setOpen(false);
  };

  return (
    <div className="relative" ref={ref}>
      <button onClick={toggle} className="flex items-center gap-2 rounded-lg px-2.5 py-1.5 text-sm text-fg hover:bg-fg/5 transition-colors max-w-[200px]">
        <Building2 className="w-4 h-4 text-fg-muted shrink-0" />
        <span className="truncate">{active?.name || 'No organization'}</span>
        <ChevronDown className="w-3.5 h-3.5 text-fg-muted shrink-0" />
      </button>
      {open && (
        <div className="absolute left-0 mt-1 w-64 z-50 bg-panel border border-panel-border rounded-lg shadow-lg py-1">
          {orgs.length > 0 && <div className="px-3 py-1.5 text-[10px] font-semibold uppercase tracking-widest text-fg-muted/70">Organizations</div>}
          {orgs.map((o) => (
            <button key={o.org_id} onClick={() => pick(o)} className="w-full flex items-center gap-2 px-3 py-2 text-sm text-fg hover:bg-fg/5 text-left">
              <Building2 className="w-4 h-4 text-fg-muted shrink-0" />
              <span className="truncate flex-1">{o.name}</span>
              <span className="text-[10px] text-fg-muted">{o.role}</span>
              {o.org_id === active?.org_id && <Check className="w-4 h-4 text-orange shrink-0" />}
            </button>
          ))}
          <button onClick={() => { setOpen(false); navigate('/organizations'); }} className="w-full flex items-center gap-2 px-3 py-2 text-sm text-fg-muted hover:text-fg hover:bg-fg/5 border-t border-panel-border">
            <Search className="w-4 h-4" /> Find or create an org
          </button>
        </div>
      )}
    </div>
  );
}
